"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heading2 = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const H2 = styled_components_1.default.span `
    display: block;
    color: inherit;
    text-transform: none;

    /* make sure to override account-management */
    &.h2 {
        margin: 0 0 16px 0;
        font-size: 34px;
        font-family: ${(p) => p.theme.fonts.heading2 || p.theme.fonts.default};
        font-weight: 300;
        line-height: 42px;
    }
`;
const Heading2 = ({ children }) => {
    return react_1.default.createElement(H2, { className: "h2" }, children);
};
exports.Heading2 = Heading2;
//# sourceMappingURL=Heading2.atom.js.map